<template>
  <div class="incenters">
    <!-- style="border: 1px solid red;" -->
    <div style="">
      <Commonbtn v-if="qx.add" backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增" fontSize="14px" @btnclick="adduser">
      </Commonbtn>
      <Commonbtn v-if="qx.update" :useAutoOptional="false" backgroundColor="#FFF" :src="require('@/assets/icon/icon-update.png')" title="修改" fontSize="14px" @btnclick="update">
      </Commonbtn>
      <Commonbtn v-if="qx.del" backgroundColor="#FFF" :src="require('@/assets/icon/icon-del.png')" title="删除" fontSize="14px" @btnclick="del">
      </Commonbtn>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div class="TableWidth">
      <Commontable @onRowClick="onRowClick"  colnum=7 :tableData="tableData" :headerData="headerData" height="100%">
      </Commontable>
      <div class="pagination">
        <!-- <Pagination></Pagination> -->
      </div>
    </div>
    <DialogFrom width="640px" title="新增用户" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
      <div class="from">
        <template v-for="(item , index) of fromdataadd">
          <Commondropdownlist :key="index" ref="adds" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
        </template>
      </div>
    </DialogFrom>
    <DialogFrom width="640px" title="修改用户" :dialogVisible="dialogVisiblesedit" @cancel="canceledit" @dialogOK="dialogOKedit">
      <div class="from">
        <template v-for="(item , index) of fromdataedit">
          <Commondropdownlist :key="index" ref="updatedit" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
        </template>
      </div>
    </DialogFrom>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该用户吗？</span>
    </Dialog>
  </div>
</template>
<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import Commontable from '../../../components/common-table.vue'
import Commonbtn from '../../../components/common-btn.vue'
import Pagination from '../../../components/pagination.vue'
import DialogFrom from '../../../components/dialog-from.vue'
import Dialog from '../../../components/dialog.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import { UserRolesList, UserRolesInfo, UserRolesEdit, UserRolesAdd, UserRolesDel } from '../../../api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
    Pagination,
    DialogFrom,
    Commondropdownlist,
    Dialog
  },
  props: {
    tableData: {
      type: Array,
      default: []
    }
  },
  data: function () {
    return {
      dialogVisibles: false,
      dialogVisiblesedit: false,
      dialogVisibledel: false,
      ptype: '',
      resdetailsList: {},
      rid: null,
      roleName: "",
      fromdataadd: [],
      fromdataedit: [],
      rowboo: false,
      qus: [],
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
      },
      // tableData: this.tabledata,
      headerData: [{
        prop: 'RID',
        label: '序号',
        columnwidth: 50
      },
      {
        prop: 'RoleName',
        label: '角色名称',
        columnwidth: 520
      },
      {
        prop: 'Remark',
        label: '描述',
        columnwidth: 790
      },
      ],
    }
  },
  mounted() {
    this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
    this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
    this.QX()
  },
  methods: {
    QX() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
      let NodeID = this.$route.query.NodeID
      data.Menus.map((item, index) => {
        if (item.NodeID == 1) {
          item.Nodes.map((items, indexs) => {
            if (items.NodeID == 3) {
              this.qus = items.Nodes
            }
          })
        }
      })
      this.qus.map((item, index) => {
        if (item.NodeName == 'add') {
          this.qx.add = true
        } else if (item.NodeName == 'edit') {
          this.qx.update = true
        } else if (item.NodeName == 'delete') {
          this.qx.del = true
        } else if (item.NodeName == 'stopif') {
          this.qx.del = true
        } else if (item.NodeName == 'assignment') {
          this.qx.assignment = true
        }
      })
      //console.log("qux", this.qus)
    },
    // 详情
    async userRolesInfo() {
      let {
        code,
        data
      } = await UserRolesInfo({
        rid: this.rid
      })
      //console.log("data", data)
      if (code == 0) {
        if (data.data) {
          this.tableData = data.data
        }
      }
    },
    // 修改
    async userRolesEdit(datalist) {
      let {
        code,
        message
      } = await UserRolesEdit({
        rid: this.rid,
        roleName: datalist[0].modelvalue,
        remark: datalist[1].modelvalue
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '修改成功'
        });
        this.$parent.userRolesList()
      } else {
        this.$message({
          type: 'info',
          message: message
        });
      }

    },
    // 新增
    async userRolesAdd(datalist) {
      let {
        code,
        data,
        message
      } = await UserRolesAdd({
        roleName: datalist[0].modelvalue,
        remark: datalist[1].modelvalue
      })
      //console.log("data", data)
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '添加成功'
        });
        this.$parent.userRolesList()
      } else {
        this.$message({
          type: 'info',
          message: message
        });
      }
      this.$refs.adds.map((item, inde) => {
        item.modelvalue = ''
      })
    },
    // 删除
    async userRolesDel() {
      let {
        code,
        message
      } = await UserRolesDel({
        rid: this.rid
      })
      //console.log("message", message)
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        this.rowboo = false
        this.$parent.userRolesList()
      } else {
        this.$message({
          type: 'info',
          message: message
        });
      }
    },
    onRowClick(val) {
      this.rowboo = true
      //console.log(val, "val")
      this.resdetailsList = val
      this.rid = val.RID

    },
    commclick(type) {
      this[type] = true
    },
    // commcancelclick(type){
    // 	this[type] = false
    // },
    // commdialogOKclick(type){
    // 	this[type] = false
    // },
    adduser() {
      this.dialogVisibles = true
      //console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      // //console.log('add', this.$refs.adds)
      this.rowboo = false
      this.userRolesAdd(this.$refs.adds)
      this.dialogVisibles = false
    },
    update() {
      if (this.rowboo == true) {
        fromdataedit[0].inputdata = this.resdetailsList.RoleName
        fromdataedit[1].inputdata = this.resdetailsList.Remark
        this.fromdataedit = fromdataedit
        this.dialogVisiblesedit = true
        this.userRolesInfo()
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要修改的数据！'
      });
    },
    canceledit() {
      this.dialogVisiblesedit = false
    },
    dialogOKedit() {
      this.userRolesEdit(this.$refs.updatedit)
      this.rowboo = false
      this.dialogVisiblesedit = false
    },
    del() {
      if (this.rowboo == true) {
        this.dialogVisibledel = true
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要删除的数据！'
      });

    },
    canceldel() {
      this.dialogVisibledel = false
    },
    dialogOKdel() {
      this.userRolesDel()
      this.dialogVisibledel = false
    },
  },
  watch: {
    // tabledata(val){
    //   this.tableData = val
    // },
    // tableData(val){
    //   this.$emit('change',val)
    // }
  }
}
</script>

<style lang="less" scoped>
.incenters {
  height: 100%;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20px;
  }

  // div {
  //   margin-left: 8px;
  //   margin-right: 8px;
  //   margin-top: 5px;
  //   margin-bottom: 5px;

  // }
  .from {
    width: 100%;
  }

  .signingroles {
    height: 500px;
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // border: 1px solid red;

    .left {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
    }

    .right {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
      // pointer-events: none;
    }
  }
}
.right-s {
  position: absolute;
  z-index: 99;
  opacity: 0.5;
  right: 21px;
  width: 470px;
  height: 240px;
  background-color: #ffffff;
  cursor: no-drop;
}
.dwonleft {
  width: 170px;
  height: 48px;
  position: absolute;
  background-color: #ffffff;
  z-index: 99;
  right: 350px;
  top: 322px;
  text-align: center;
  line-height: 48px;
  color: #333333;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
}
.dwonleft:hover {
  background-color: #f0f0f0;
}
</style>
